import {
  CommandBar,
  DetailsList,
  GroupHeader,
  SelectionMode,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { useFilterAndSort } from './invitationGroupAdminPanelAndList/utility/useFilterAndSort';
import { useInteractions } from './invitationGroupAdminPanelAndList/utility/useInteractions';
import { useData } from './invitationGroupAdminPanelAndList/utility/useData';
import {
  getCommandBarItems,
  getCommandBarSearchFilter,
} from './invitationGroupAdminPanelAndList/utility/getCommandBarItems';
import { columns } from './invitationGroupAdminPanelAndList/utility/getColumns';
import { UpdateInvitationGroupPanel } from './invitationGroupAdminPanelAndList/UpdateInvitationGroupPanel';
import { DeleteInvitationGroupPanel } from './invitationGroupAdminPanelAndList/DeleteInvitationGroupPanel';
import { CreateInvitationGroupPanel } from './invitationGroupAdminPanelAndList/CreateInvitationGroupPanel';
import { ManageInvitationKeysPanel } from './invitationGroupAdminPanelAndList/ManageInvitationKeysPanel';

export const InvitationGroupAdminPanelAndList = () => {
  const { t: translator } = useTranslation();

  const { allInvitationGroups, allInvitationKeys } = useData();

  const {
    titleFilter,
    handleTitleFilterChange,
    filteredAndSortedItems,
    groups,
  } = useFilterAndSort(allInvitationGroups, allInvitationKeys);

  const {
    selectedInvitationGroupKey,
    setSelectedInvitationGroupKey,
    isGroupSelected,
    onGroupClick,
    handleCreateInvitationGroup,
    handleUpdateInvitationGroup,
    handleDeleteInvitationGroup,
    handleManageInvitationKeys,
  } = useInteractions();

  return (
    <div className="admin-page-container-header invitationGroupAdminPanelAndList">
      <div className="title-column">
        <h3 className="SFont">
          {translator(
            'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.header',
          )}
        </h3>
      </div>
      <CommandBar
        items={getCommandBarItems(
          translator,
          handleCreateInvitationGroup,
          handleUpdateInvitationGroup,
          handleDeleteInvitationGroup,
          handleManageInvitationKeys,
          selectedInvitationGroupKey,
        )}
        farItems={getCommandBarSearchFilter(
          translator,
          titleFilter,
          handleTitleFilterChange,
        )}
        shiftOnReduce={false}
        className="admin-commandBar"
        ariaLabel={translator('ariaLabel.pageHeaderMenu')}
      />
      <DetailsList
        compact={false}
        items={filteredAndSortedItems}
        groups={groups}
        selectionMode={SelectionMode.none}
        ariaLabel={translator('ariaLabel.invitationGroupListLabel')}
        ariaLabelForSelectAllCheckbox={translator('ariaLabel.listSelectAll')}
        columns={columns(translator)}
        groupProps={{
          showEmptyGroups: true,
          onRenderHeader: (props) => {
            return (
              <GroupHeader
                {...props}
                onGroupHeaderClick={(group) => onGroupClick(group.data.groupId)}
                className={
                  isGroupSelected(props.group.data.groupId)
                    ? 'group-header--selected'
                    : 'group-header'
                }
              />
            );
          },
        }}
      />
      <CreateInvitationGroupPanel invitationGroups={allInvitationGroups} />
      <UpdateInvitationGroupPanel
        invitationGroups={allInvitationGroups}
        selectedInvitationGroupKey={selectedInvitationGroupKey}
      />
      <DeleteInvitationGroupPanel
        selectedInvitationGroupKey={selectedInvitationGroupKey}
        setSelectedInvitationGroupKey={setSelectedInvitationGroupKey}
      />
      <ManageInvitationKeysPanel
        selectedInvitationGroupKey={selectedInvitationGroupKey}
        allInvitationGroups={allInvitationGroups}
        allInvitationKeys={allInvitationKeys}
      />
    </div>
  );
};
